module.exports = __webpack_public_path__ + "ca00cb0feec18b2944bc019b57bc93a3.jpg";